export default function searchFilters() {
	const run = function () {
		$('[data-filter="brand"] > input')
			.off()
			.on('keyup', function (e) {
				// eslint-disable-next-line prefer-const
				const el = $(e.target),
					filter = $(el).parent(),
					value = e.target.value;
				if (!value || value.length < 3) {
					filter.siblings('ul').find('li').show();
				} else {
					filter
						.siblings('ul')
						.find('li > input')
						.each(function () {
							const val = $(this).data('name');
							if (val) {
								if (
									val
										.toLowerCase()
										.indexOf(value.toLowerCase()) >= 0
								) {
									$(this).parent('li').show();
								} else {
									$(this).parent().hide();
								}
							}
						});
				}
			});
	};
	$(document).on('berocket_ajax_filtering_end', function () {
		run();
	});
	$(document).on('berocket_ajax_products_loaded', function () {
		run();
	});
	run();
}
